var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWelcomeBottom = function SvgWelcomeBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CD1C45",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.575,
    cy: 55.803,
    r: 13.398,
    transform: "rotate(90 57.575 55.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.16 23.55 22.578.495s-5.535 6.35-5.458 11.91c.074 5.38 5.458 12.653 5.458 12.653H46.161s4.877-7.108 4.962-12.654c.088-5.719-4.962-12.405-4.962-12.405z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.575,
    cy: 16.602,
    r: 13.398,
    transform: "rotate(90 57.575 16.602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.986 27.575.497-22.577s6.349 5.535 11.909 5.458c5.38-.074 12.653-5.458 12.653-5.458v22.577s-7.108-4.877-12.654-4.962c-5.719-.088-12.405 4.962-12.405 4.962"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.04,
    cy: 16.162,
    r: 13.398
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 91.677,
    cy: 55.577,
    r: 13.398,
    opacity: 0.3,
    transform: "rotate(90 91.677 55.577)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.573,
    cy: 94.552,
    r: 13.398,
    opacity: 0.08,
    transform: "rotate(90 57.573 94.552)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.471,
    cy: 94.552,
    r: 13.398,
    opacity: 0.3,
    transform: "rotate(90 23.471 94.552)"
  }))));
};
export default SvgWelcomeBottom;